export const SENSOR_CODE = {
  FUEL_ULTRASONIC: 60,
  FUEL_OBD: 69,
  FUEL_DIGITAL: 33,
  FUEL_ODO: 32,
}

export const SENSOR_TYPE = {
  FUEL_STICK: [50, 51, 52, 53],
}

export const SENSOR_PIN_CODE = {
  FUEL_OBD: 119,
  FUEL_LEVEL_OBD_1: 89,
  FUEL_LEVEL_OBD_2: 84,
}
